module.exports = __webpack_public_path__ + "static/media/05.f8cb5888.mp3";